import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { ClientModel } from '../models/client.model';
import { EnabledDynamicFieldModel } from '../models/dynamicfield/enabled-dynamicfield.model';
import { HydraCollection } from '../hydra/hydra-collection';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ClientApiService extends ApiService {
  readonly resourcePath = 'clients';

  get(id: string): Observable<ClientModel> {
    return this.restRead<ClientModel>(id);
  }

  getCustomFieldsForPerson(client:string):Observable<HydraCollection<EnabledDynamicFieldModel>> {
    return this.http.get<HydraCollection<EnabledDynamicFieldModel>>(this.resourceUrl +"/"+ client + "/enabled_dynamic_fields?enabledForPersons=1").pipe(
      map(response => new HydraCollection<EnabledDynamicFieldModel>(response))
    );
  }

  getCustomFieldsForOrganisation(client:string):Observable<HydraCollection<EnabledDynamicFieldModel>> {
    return this.http.get<HydraCollection<EnabledDynamicFieldModel>>(this.resourceUrl +"/"+ client + "/enabled_dynamic_fields?enabledForOrganisations=1").pipe(
      map(response => new HydraCollection<EnabledDynamicFieldModel>(response))
    );
  }
  getCustomFieldsForEnrolment(client:string):Observable<HydraCollection<EnabledDynamicFieldModel>> {
    return this.http.get<HydraCollection<EnabledDynamicFieldModel>>(this.resourceUrl +"/"+ client + "/enabled_dynamic_fields?enabledForEnrolments=1").pipe(
      map(response => new HydraCollection<EnabledDynamicFieldModel>(response))
    );
  }

  sendStat(body:object){
    return this.http.post(this.apiUrl +'/a/e',body);
    
  }
}
